import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function ServiceImageGallery({ images, title }) {
    return (
        <MKBox component="section" py={6}>
            <Container>
                <MKTypography
                    variant="h2"
                    color="dark"
                    textAlign="center"
                    mb={4}
                    sx={{ textWrap: "balance" }}
                >
                    {title}
                </MKTypography>
                <Grid container spacing={3} justifyContent="center">
                    {images.map(({ src, alt }) => (
                        <Grid item xs={12} md={4} key={src}>
                            <MKBox
                                component="img"
                                src={src}
                                alt={alt}
                                loading="lazy"
                                width="100%"
                                borderRadius="lg"
                                sx={{
                                    height: 280,
                                    objectFit: "cover",
                                    outline: "1px solid rgba(0, 0, 0, 0.1)",
                                    outlineOffset: "-1px",
                                }}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </MKBox>
    );
}

ServiceImageGallery.defaultProps = { title: "Galerie foto" };
ServiceImageGallery.propTypes = {
    title: PropTypes.string,
    images: PropTypes.arrayOf(
        PropTypes.shape({ src: PropTypes.string.isRequired, alt: PropTypes.string.isRequired })
    ).isRequired,
};

export default ServiceImageGallery;
